export default "__VITE_ASSET__BdAsd_oC__"